import React from "react";
import {ResponsivePie} from "@nivo/pie";
import {useColorMode} from "@chakra-ui/react";
import {noYesColors} from "variables/colors";
import Loading from "components/Loading/Loading";
import {useDemographicDash} from "hooks/demographicDash";
import {border, themeDark, tooltip} from "variables/nivo/default";
import {
    arc,
    arcLabelsTextColor,
    arcLinkLabelsColor,
    legendsDark,
    legendsLight,
    margin,
    pieProps
} from "variables/nivo/halfPie";


const total = (data) => {
    let total = 0;
    data.map(item => {
        total += item.value;
    });

    return total;
};

const MedicineChart = () => {
    const { isLoadingGetControlledMedication: isLoading, dash_val: data } = useDemographicDash();

    const { colorMode } = useColorMode();

    if (!isLoading && !!data && !!data.get_controlled_medication) {
        return (
            <ResponsivePie
                data={data.get_controlled_medication}
                margin={margin}
                colors={['#15ADA7', '#3E993C']}
                theme={themeDark}
                {...border}
                {...arc}
                arcLinkLabelsColor={arcLinkLabelsColor}
                arcLabelsTextColor={arcLabelsTextColor}
                legends={colorMode === "light" ? legendsLight : legendsDark}
                tooltip={({datum}) => tooltip(datum.label, datum.value, total(data.get_controlled_medication), datum.color)}
                {...pieProps}
                innerRadius={0.7}
            />
        )
    }
    return <Loading/>;
};

export default MedicineChart
